module.exports = __webpack_public_path__ + "static/media/slide_4.dae39d20.jpg";